
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import StarXpGate from '@/components/star/StarXpGate.vue'
import { isXpLowVersion } from '@/utils/xpEnv'
import { useStarRouter } from '@/utils/useStarTheme'
import starApi from '@/api/starApi'

interface HistoryItem {
  taskID: string
  title: string
  quantType: number
  backTestTime: number
}

function formatTitle(item: HistoryItem): string {
  return item.title
}

function formatTime(ts: number): string {
  if (!ts) return '--'
  const d = new Date(ts)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

export default defineComponent({
  name: 'StarResult',
  components: { StarXpGate },
  setup() {
    const route = useRoute()
    const { starPush } = useStarRouter()
    const loading = ref(false)
    const list = ref<HistoryItem[]>([])

    const fetchList = async () => {
      loading.value = true
      try {
        const token = route.query.token as string
        const res = await starApi.getBacktestHistory({ headers: { token } })
        list.value = (res?.data?.list || []).sort((a: HistoryItem, b: HistoryItem) => b.backTestTime - a.backTestTime)
      } catch (e) {
        list.value = []
      } finally {
        loading.value = false
      }
    }

    const goDetail = (item: HistoryItem) => {
      const quantType = Number(item.quantType)
      const isGroup = quantType === 3 || quantType === 4
      const query: Record<string, string> = {
        taskID: item.taskID,
        title: item.title,
        quantType: String(quantType),
        isfrom: '1',
        fromRecord: '1',
      }
      // quantType=4：组合量化（策略口令）
      if (quantType === 4) query.isFactor = '1'
      starPush(isGroup ? '/star/group/result' : '/star/stock/result', query)
    }

    onMounted(() => {
      if (isXpLowVersion(route.query as Record<string, unknown>)) return
      fetchList()
    })

    return { loading, list, formatTitle, formatTime, goDetail }
  }
})
